import ModalGallerySlider from "../components/ModalGallerySlider";

export default {
  init() {
    const gallerySwiper = new ModalGallerySlider($("#modal-gallery-page"));

    $("a.toggle-gallery-modal").on("click", function(e) {
      e.preventDefault();
      const targetModal = $(this).data("target");
      const swipeIdx = parseInt($(this).data("swipe-index"));
      $(targetModal).addClass("active");
      gallerySwiper.swiper.update();
      gallerySwiper.swiper.slideTo(swipeIdx);
    });

    $(
      ".advanced-country-blocks .country-blocks-wrap a.country-block-inner.country-block-popup"
    ).on("click", function(e) {
      e.preventDefault();
      const sectionIndex = $(this).data("section-idx");
      const blockIndex = $(this).data("block-idx");

      const modal = $(
        ".modal.country-popup-modal-" + sectionIndex + "-" + blockIndex
      );

      if (modal.length) {
        modal.modal().show();
      }
    });

    $(
      ".advanced-country-blocks .country-blocks-wrap a.country-block-inner.country-block-scroll"
    ).on("click", function(e) {
      e.preventDefault();
      const target = $(this).attr("href");
      const header =
        $(window).width() > 1024
          ? false
          : jQuery(".site-header-mobile")[0].scrollHeight;

      if ($(target).length > 0) {
        let offset = $(target).offset().top;

        if (header) {
          offset = offset - header;
        } else {
          offset = offset - 150;
        }

        $("body, html").animate(
          {
            scrollTop: offset
          },
          "slow"
        );
      }
    });
  }
};
